import { useMemo } from "react";
import { GroupCategoryResponse } from "../../api/gms/group-category/group-category-api-state";

interface Props {
    defaultProposalAs: { id: number; name: string; };
    statusProposalType: GroupCategoryResponse[] | undefined;
    selectedProposalTypeId: number | undefined;
}

export const useProposalTypeDataUseMemo = ({ defaultProposalAs, statusProposalType, selectedProposalTypeId }: Props) => {

    const proposalTypeOptions = useMemo(() => {
        return [
            defaultProposalAs,
            ...(statusProposalType?.map((item) => ({
                id: item.id,
                name: item.name,
            })) || [])
        ];
    }, [defaultProposalAs, statusProposalType]);


    const proposalTypeValue = useMemo(() => {
        return ( proposalTypeOptions.find(opt => opt.id === selectedProposalTypeId) || defaultProposalAs );
    }, [selectedProposalTypeId, proposalTypeOptions, defaultProposalAs]);

    return {
        proposalTypeOptions,
        proposalTypeValue
    }
}